
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class ListItemDialog extends Serenity.EntityDialog<ListItemRow, any> {
        protected getFormKey() { return ListItemForm.formKey; }
        protected getIdProperty() { return ListItemRow.idProperty; }
        protected getLocalTextPrefix() { return ListItemRow.localTextPrefix; }
        protected getNameProperty() { return ListItemRow.nameProperty; }
        protected getService() { return ListItemService.baseUrl; }

        protected form = new ListItemForm(this.idPrefix);

        protected getSaveEntity() {
            var ent = super.getSaveEntity();
            ent.ListCode = ent.ListCode || this.entity.ListCode;
            return ent;
        }

    }
}